<template>
  <div class="Home">
    <van-skeleton title v-if="showDetail" :row="14" />
    <div v-else>
      <div class="part1">
        <div class="p1_line_1">
          <div>日销售额(元)</div>
          <!-- <div>
            <span>查看更多</span>
            <van-icon name="arrow" size="0.28rem" style="line-height:0.32rem" />
          </div>-->
        </div>
        <div class="p1_line_2">
          <span>{{Number (detailData.taday_sum).toFixed(2)}}</span>
          <span>
            {{detailData.taday_count||0}}
            <span>(单)</span>
          </span>
        </div>
        <div class="p1_line_3">
          <span>今日还款(元)</span>
          <span>+{{Number(detailData.today_annal).toFixed(2)}}</span>
        </div>
        <div class="p1_line_4">
          <div @click="toAddCAredit">
            <img src="./../../assets/img/layout/home/szlr_icon.png" alt />
            <span>订单补录</span>
          </div>
          <div @click="toFasePayment">
            <img src="./../../assets/img/layout/home/kshk_icon.png" alt />
            <span>快速还款</span>
          </div>
        </div>
        <div class="p1_line_5" @click="toCreditList">
          <div>总欠款额(元)</div>
          <div>
            <span>{{Number(detailData.credit_all_sum).toFixed(2)}}</span>
            <van-icon name="arrow" size="0.28rem" />
          </div>
        </div>
      </div>

      <div class="part2">
        <div class="p_title">今日营业概况</div>
        <div class="p_con">
          <!-- <div>
            <span>销售额</span>
            <span>{{detailData.month_count||0}}笔</span>
            <span>
              <span>￥{{Number (detailData.month_price).toFixed(2)}}</span>
            </span>
          </div>-->
          <div>
            <span style="font-weight:normal">实收额</span>
            <span style="font-weight:normal">
              <!-- {{detailData.month_count||0}}笔 -->
            </span>
            <span>
              <span>￥{{Number (detailData.real_price).toFixed(2)}}</span>
              <!-- <span>
                <van-icon name="arrow" size="0.28rem" color="#999999" />
              </span>-->
            </span>
          </div>
          <div>
            <span style="font-weight:normal">赊欠额</span>
            <span style="font-weight:normal">
              <!-- {{detailData.credit_count||0}}笔 -->
            </span>
            <span>
              <span>￥{{Number (detailData.credit_sum).toFixed(2)}}</span>
              <!-- <span>
                <van-icon name="arrow" size="0.28rem" color="#999999" />
              </span>-->
            </span>
          </div>
          <!-- <div v-if="Number (detailData.month_repayment_discount) != 0">
            <span style="font-weight:normal">还款优惠</span>
            <span style="font-weight:normal">
              {{detailData.credit_count||0}}笔
              </span>
            <span>
              <span>￥{{Number (detailData.month_repayment_discount).toFixed(2)}}</span>
            </span>
          </div>-->
          <div>
            <span
              style="font-weight:normal"
              v-if="Number(detailData.taday_receivables).toFixed(2)<=0"
            >订单优惠</span>
            <span
              style="font-weight:normal"
              v-if="Number(detailData.taday_receivables).toFixed(2)>0"
            >订单多收</span>
            <span style="font-weight:normal">
              <!-- {{detailData.credit_count||0}}笔 -->
            </span>
            <span>
              <span>￥{{Math.abs(Number (detailData.taday_receivables).toFixed(2))}}</span>
              <!-- <span>
                <van-icon name="arrow" size="0.28rem" color="#999999" />
              </span>-->
            </span>
          </div>
        </div>
      </div>
      <div class="part3" v-if="detailData.real_price>0">
        <div class="p_head">
          <span>今日收银概况</span>
        </div>
        <div class="p_con" style="padding:0 0.24rem">
          <!-- <div v-for="(item,index) in detailData.payment_channel" :key="index">
            <span style="font-weight:normal" v-if="item.pay_type==1">现金</span>
            <span style="font-weight:normal" v-if="item.pay_type==2">支付宝</span>
            <span style="font-weight:normal" v-if="item.pay_type==3">微信</span>
            <span style="font-weight:normal" v-if="item.pay_type==4">银行卡</span>
            <span style="font-weight:normal" v-if="item.pay_type==5">pos</span>
            <span style="font-weight:normal">
            </span>
            <span>
              <span>￥{{Number (item.payment).toFixed(2)}}</span>
            </span>
          </div>-->
          <div id="chartPie" style="width:100%;height:6rem"></div>
        </div>
      </div>

      <div class="part3">
        <div class="p_head">
          <span>收入趋势</span>
          <!-- <div>
          <span>销售额</span>
          <span>赊欠额</span>
          </div>-->
        </div>
        <div class="p_con">
          <div id="myChart" style="width:100%;height:250px"></div>
        </div>
      </div>
      <div class="openOrder" v-if="role_type == 1" @click="toOpenOrder">
        <img src="./../../assets/img/layout/home/open_order.png" alt />
      </div>
      <div class="openOrder" v-if="role_type == 2" @click="toOpenOrder">
        <img src="./../../assets/img/layout/home/open_checkout.png" alt />
      </div>
      <!-- <div class="openOrder CheckOut" @click="toOpenOrderCheckOut">
        <img src="./../../assets/img/layout/home/open_order.png" alt />
      </div>-->
    </div>
  </div>
</template>

<script>
import { getHomeData, getUserData } from "@/api/layout/home";
import { timestampToDate } from "@/utils/timestamp";
import Cookies from "@/utils/Cookies";
export default {
  name: "Home",
  data() {
    return {
      chart: "", // 图表变量
      detailData: {},
      showDetail: true,
      role_type: 0 // 1 开单 2 结账
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch("getAuth").then(res => {
        if (res.includes(1) && !res.includes(2)) {
          vm.role_type = 1;
        } else if (res.includes(2)) {
          vm.role_type = 2;
        } else {
          vm.role_type = "";
        }
      });
    });
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.getData();
    }, 200);
  },
  methods: {
    // 获取数据
    getData() {
      getHomeData().then(res => {
        if (res.code == 200) {
          this.showDetail = false;
          this.detailData = res.data;
          this.$nextTick(() => {
            var xse = [];
            var sqe = [];
            var xsl = [];
            var sql = [];
            var data_echart = {
              date: [],
              echarts: []
            };
            for (let i = 0; i < this.detailData.date_date.length; i++) {
              const item = this.detailData.date_date[i];
              data_echart.date.push(item.date.substring(5));
              xse.push(item.receivables || 0);
              sqe.push(item.credit || 0);
              xsl.push(item.count || 0);
              sql.push(item.credit_count || 0);
            }
            data_echart.echarts = [xse, sqe, xsl, sql];
            this.drawEchart("myChart", data_echart);
            let channel = [];
            for (let i = 0; i < res.data.payment_channel.length; i++) {
              if (res.data.payment_channel[i].pay_type == 1) {
                channel.push({
                  name: "现金",
                  value: res.data.payment_channel[i].payment?res.data.payment_channel[i].payment:null
                });
              } else if (res.data.payment_channel[i].pay_type == 2) {
                channel.push({
                  name: "支付宝",
                  value: res.data.payment_channel[i].payment?res.data.payment_channel[i].payment:null
                });
              } else if (res.data.payment_channel[i].pay_type == 3) {
                channel.push({
                  name: "微信",
                  value: res.data.payment_channel[i].payment?res.data.payment_channel[i].payment:null
                });
              } else if (res.data.payment_channel[i].pay_type == 4) {
                channel.push({
                  name: "银行卡",
                  value: res.data.payment_channel[i].payment?res.data.payment_channel[i].payment:null
                });
              } else if (res.data.payment_channel[i].pay_type == 5) {
                channel.push({
                  name: "POS",
                  value: res.data.payment_channel[i].payment?res.data.payment_channel[i].payment:null
                });
              }
            }
            this.drawPie("chartPie", channel);
          });
        }
      });
    },
    // 初始化echart
    drawEchart(id, data) {
      this.chart = this.$echarts.init(document.getElementById(id));
      this.chart.setOption({
        backgroundColor: "", //背景颜色透明
        color: "#31b158",
        tooltip: {
          trigger: "axis", //鼠标经过提示
          axisPointer: {
            z: 3
          },
          formatter: params => {
            var name = ["销售笔数", "赊欠笔数"];
            return `
              <div>
                <div>${params[0].name}</div>
                <div>
                  <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#31b158;"></span>${
                    params[0].seriesName
                  }:${data.echarts[params[0].seriesIndex][params[0].dataIndex]}
                </div>
                <div>
                  <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#31b158;"></span>${
                    name[params[0].seriesIndex]
                  }:${
              data.echarts[params[0].seriesIndex + 2][params[0].dataIndex]
            }
                </div>
              </div>`;
          }
        },
        legend: {
          selectedMode: "single",
          icon: "circle", //icon为圆角矩形
          x: "center",
          y: "10",
          data: ["销售额", "赊欠额"],
          textStyle: {
            //图例文字的样式
            color: "#31b158",
            fontSize: 12
          }
        },
        grid: {
          right: "5%",
          top: "20%",
          left: "5%",
          bottom: "15%"
          // containLabel: true
        },
        xAxis: {
          type: "category",
          data: data.date,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#dedede"
            }
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: "#dedede"
            }
          }
        },
        yAxis: {
          type: "value",
          splitLine: { show: false }, //去除网格线
          show: false //隐藏y轴
        },
        series: [
          {
            name: "销售额",
            data: data.echarts[0],
            type: "line",
            smooth: true,
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#31b158" },
                  { offset: 1, color: "#fff" }
                ])
              }
            }, //填充区域样式
            lineStyle: {
              color: "#31b158",
              width: 1
            }, //线条的样式
            itemStyle: {
              opacity: 0 //为0不会绘制图形拐点消失
            } //拐点的样式
          },
          {
            name: "赊欠额",
            data: data.echarts[1],
            type: "line",
            smooth: true,
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#31b158" },
                  { offset: 1, color: "#fff" }
                ])
              }
            }, //填充区域样式
            lineStyle: {
              color: "#31b158",
              width: 1
            }, //线条的样式
            itemStyle: {
              //   color: "rgb(255, 70, 131)",
              opacity: 0 //为0不会绘制图形拐点消失
            } //拐点的样式
          }
        ]
      });
    },
    //初始化圆饼图
    drawPie(id, channelData) {
      this.chart = this.$echarts.init(document.getElementById(id));
      console.log(this.chart);
      let color = ["#5b9bd5", "#ed7d31", "#a9d18e", "#ffc000", "#06d3c4"];
      this.chart.setOption({
        name: "访问来源",
        type: "pie",
        radius: "30%",
        center: ["30%", "55%"],
        // itemStyle: {
        //   normal: {
        //     color: function(params) {
        //       return color[params.dataIndex];
        //     }
        //   }
        // },
        label: {
          position: "inner",
          fontSize: 14,
          formatter: function(params) {
            var str=`${params.name}:￥${params.value} `
            if(params.value>0){
              return str.split(":").join("\n")
            }
            
          },
          show: true
        },
        series: [
          {
            name: "今日收银概况",
            type: "pie",
            radius: "55%",
            data: channelData
          }
        ],
        color: ["#f89588", "#63b2ee", "#76da91", "#7cd6cf",'#f8cb7f'],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)"
          }
        }
      });
    },
    // 去开单页面
    toOpenOrder() {
      if (this.role_type == 2) {
        this.$router.push({
          path: "/openOrder/orderCheckOut"
        });
      } else {
        this.$router.push({
          path: "/openOrder/order"
        });
      }
    },
    // 去收银台页面
    toOpenOrderCheckOut() {
      this.$router.push({
        path: "/openOrder/order"
      });
    },
    // 去欠款列表
    toCreditList() {
      this.$router.push({
        path: "/credit/creditList"
      });
    },
    // 去订单补录
    toAddCAredit() {
      this.$router.push({
        path: "/credit/addCredit"
      });
    },
    // 去经营户查询
    toFasePayment() {
      this.$router.push({
        path: "/credit/fastPayment"
      });
    },
    // 去法律规范
    toLawList(part) {
      this.$router.push({
        path: "/lawList",
        query: {
          part
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.Home {
  position: relative;
  .part1 {
    width: 100%;
    height: 4.3rem;
    box-sizing: border-box;
    background: url(./../../assets/img/layout/home/bg.png) no-repeat center
      bottom;
    background-size: 100%;
    color: #fff;
    padding: 0.5rem 0.3rem 0;
    font-size: 0.28rem;
    margin-bottom: 1.1rem;
    position: relative;
    .p1_line_1 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.34rem;
      & > div:nth-child(2) {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    .p1_line_2 {
      font-size: 0.48rem;
      letter-spacing: 0.01rem;
      font-weight: bold;
      margin-bottom: 0.4rem;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      & > span {
        font-size: 0.6rem;
        &:nth-child(1) {
          width: 4rem;
        }
        &:nth-child(2) {
          span {
            font-size: 0.3rem;
            vertical-align: middle;
          }
        }
      }
    }
    .p1_line_3 {
      font-size: 0.28rem;
      & > span:nth-child(2) {
        color: #fde07d;
        margin-left: 0.12rem;
      }
    }
    .p1_line_4 {
      width: 6.4rem;
      margin-left: -3.2rem;
      height: 0.8rem;
      background: url(./../../assets/img/layout/home/bg_1.png) no-repeat center
        bottom;
      background-size: 100%;
      border-radius: 0.1rem 0.1rem 0px 0px;
      position: absolute;
      left: 50%;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      & > div {
        width: 50%;
        height: 0.28rem;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 0.24rem;
          height: 0.26rem;
        }
        span {
          font-size: 0.28rem;
          color: #d1c1a7;
          line-height: 0.28rem;
          margin-left: 0.1rem;
        }
        &:nth-child(1) {
          border-right: 0.005rem solid #d1c1a7;
        }
      }
    }
    .p1_line_5 {
      width: 6.4rem;
      margin-left: -3.2rem;
      height: 0.8rem;
      background: #ffffff;
      border-radius: 0px 0px 0.1rem 0.1rem;
      position: absolute;
      left: 50%;
      box-shadow: 0px 0.05rem 0.16rem 0px rgba(204, 204, 204, 0.3);
      bottom: -0.8rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.3rem;
      color: #333;
      font-weight: bold;
      box-sizing: border-box;
      font-size: 0.28rem;
      & > div:nth-child(2) {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        span {
          margin-right: 0.1rem;
        }
      }
    }
  }

  .part2 {
    width: 100%;
    background-color: #fff;
    padding: 0 0.3rem;
    box-sizing: border-box;
    color: #333;
    margin-bottom: 0.2rem;
    padding-bottom: 0.1rem;
    .p_title {
      font-weight: bold;
      line-height: 1rem;
      border-bottom: 0.01rem solid #e6e6e6;
    }
    .p_con {
      margin-top: 0.2rem;
      width: 100%;
      box-sizing: border-box;
      // padding-left: 0.48rem;
      // padding: 0 0.26rem;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      div {
        width: 50%;
        box-sizing: border-box;
        border-bottom: 0.01rem solid #e6e6e6;
        border-right: 0.01rem solid #e6e6e6;
        padding: 0 0.26rem;
        height: 0.92rem;
        font-size: 0.28rem;
        line-height: 0.28rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: space-between;
        & > span:nth-child(1) {
          width: 50%;
        }
        & > span:nth-child(2) {
          width: 0%;
        }
        & > span:nth-child(3) {
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          color: #31b158;
        }
        &:nth-child(3),
        &:nth-child(4) {
          border-bottom: none;
        }
        &:nth-child(2n) {
          border-right: none;
        }
      }
    }
  }
  .part4 {
    width: 100%;
    background-color: #fff;
    padding: 0 0.3rem;
    box-sizing: border-box;
    color: #333;
    margin-bottom: 0.2rem;
    padding-bottom: 0.1rem;
    .p_title {
      font-weight: bold;
      line-height: 1rem;
      border-bottom: 0.01rem solid #e6e6e6;
    }
    .p_con {
      margin-top: 0.2rem;
      width: 100%;
      box-sizing: border-box;
      // padding-left: 0.48rem;
      // padding: 0 0.26rem;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      div {
        width: 50%;
        box-sizing: border-box;
        border-bottom: 0.01rem solid #e6e6e6;
        border-right: 0.01rem solid #e6e6e6;
        padding: 0 0.26rem;
        height: 0.92rem;
        font-size: 0.28rem;
        line-height: 0.28rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: space-between;
        & > span:nth-child(1) {
          width: 50%;
        }
        & > span:nth-child(2) {
          width: 0%;
        }
        & > span:nth-child(3) {
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          color: #31b158;
        }
        &:nth-child(2n) {
          border-right: none;
        }
        &:nth-last-child(1) {
          border-bottom: none;
        }
      }
    }
  }

  .part3 {
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    color: #333;
    margin-bottom: 0.2rem;
    padding-bottom: 0.1rem;
    .p_head {
      display: flex;
      padding: 0 0.3rem;
      align-items: center;
      justify-content: space-between;
      border-bottom: 0.01rem solid #e6e6e6;
      & > span:nth-child(1) {
        font-weight: bold;
        line-height: 1rem;
      }
    }
  }

  .openOrder {
    width: 1.55rem;
    height: 1.55rem;
    position: fixed;
    right: 0.22rem;
    bottom: 4rem;
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
    &.CheckOut {
      bottom: 2rem;
    }
  }
}
</style>